import React from 'react'
import LocationSection from './subcomponents/section/LocationSection';
import { graphql } from 'gatsby'
import { observer } from 'mobx-react-lite';
import { useStore } from '../../../../hooks/useStore';
import { LocationCloseButton } from './subcomponents/close-button';
import { MapCityMenu } from '../map-section/subcomponents/map-nav-ui/subcomponents';
import { LocationListCityMenu } from './subcomponents/city-menu';

const LocationList = observer(({data}) => {
    const {uiStore: {home__locationListOpen, home__locationList__activeCity}} = useStore();
    // if (!home__locationListOpen && !isMobile) return null;

    let orgData;
    switch(home__locationList__activeCity) {
        case "Atlanta":
            orgData = data.orgsAtlanta.edges;
            break;
        case "Chicago":
            orgData = data.orgsChicago.edges;
            break;
        
        case "Detroit":
            orgData = data.orgsDetroit.edges;
            break;
        case "Philadelphia":
            orgData = data.orgsPhiladelphia.edges;
            break;
        case "LA":
            orgData = data.orgsLA.edges;
        break;
        case "Buffalo":
            orgData = data.orgsBuffalo.edges;
        break;
        default:
            orgData = data.orgsAtlanta.edges;

    }


    return (

        <div className={home__locationListOpen ? "location-list" : "location-list hide"}>
            <LocationCloseButton/>
            <div className="text-section elevate">
                <h2 className="text-xl">Get to know your local heroes</h2>
            </div>
            <LocationListCityMenu/>
            <LocationSection data={orgData} city={home__locationList__activeCity}/>

            <style jsx>{`
                .location-list {
                    background: var(--color--pink--transparent);
                    position: fixed;
                    z-index: 100;
                    top: var(--nav--height);
                    left: 0;
                    width: 100%;
                    height: 100%;
                    overflow: scroll;
                    padding-bottom: 100px;
                    overscroll-behavior: none; 
                    transition: opacity .3s ease;
                }


                .hide {
                    opacity: 0;
                    pointer-events: none;
                }

                .location-list :global(.location-city-menu) {
                    position: fixed;
                    z-index: 10;
                    top: 80px;
                    left: 30px;
                }

                h2 {
                    text-align: center;
                    max-width: 600px;
                    margin: 0 auto;
                }
                .text-section {
                    margin: 100px 0;
                }

                @media (pointer: coarse), (max-width: 769px) {
                    .location-list {
                        position: relative;
                        padding: 20px;
                        top: 0;
                        padding-top: 60px;
                        opacity: 1;
                        pointer-events: all;
                        overscroll-behavior: initial; 
                        height: auto;
                        overflow: initial;
                    }

                    .text-section {
                        margin: 20px 0;
                    }

                    .location-list :global(.location-city-menu) {
                        position: relative;
                        top: initial;
                        left: initial;
                        margin: 80px auto;
                        // top: 20px;
                        // left: 50%;
                        // transform: translateX(-50%);
                    }
                }

            `}</style>
        </div>
    )   
});


 



export default LocationList